'use client';

import React, { useEffect, useRef } from 'react';

interface Reference {
  name: string;
  title?: string;
  phone?: string;
  email: string;
  color: string;
  initial: string;
}

const references: Reference[] = [
  {
    name: 'David Souery',
    title: 'Co-Founder, Nightborn Agency (Brussels)',
    phone: '0468 100 797',
    email: 'hello@nightborn.com',
    color: '#DA3420',
    initial: 'D',
  },
  {
    name: 'Rikolto Contact',
    email: 'irene.salvi@rikolto.org',
    color: '#06b6d4',
    initial: 'R',
  },
];

export default function Testimonials() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.animate-on-scroll').forEach((el, i) => {
              setTimeout(() => el.classList.add('visible'), i * 150);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="testimonials" className="bg-white py-24 md:py-32" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-5 md:px-16 lg:px-24">
        {/* Header */}
        <div className="mb-16">
          <span className="section-label animate-on-scroll">05 — References</span>
          <h2
            className="section-title mt-4 animate-on-scroll"
            style={{ fontSize: 'clamp(2.5rem, 5vw, 5rem)' }}
          >
            Refer
            <br />
            <span className="text-primary">ences</span>
          </h2>
        </div>

        {/* References grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-secondary-dark max-w-3xl">
          {references.map((ref) => (
            <div
              key={ref.email}
              className="bg-white p-8 md:p-10 animate-on-scroll flex flex-col gap-4"
            >
              {/* Avatar + Name */}
              <div className="flex items-center gap-4">
                <div
                  className="w-10 h-10 flex items-center justify-center font-condensed font-bold text-white flex-shrink-0"
                  style={{ backgroundColor: ref.color }}
                >
                  {ref.initial}
                </div>
                <div>
                  <p className="font-condensed font-bold uppercase text-dark" style={{ fontSize: '0.95rem' }}>
                    {ref.name}
                  </p>
                  {ref.title && (
                    <p className="font-sans text-dark opacity-60" style={{ fontSize: '0.8rem' }}>
                      {ref.title}
                    </p>
                  )}
                </div>
              </div>

              {/* Contact details */}
              <div className="flex flex-col gap-1 pl-14">
                {ref.phone && (
                  <a
                    href={`tel:${ref.phone.replace(/\s/g, '')}`}
                    className="font-sans text-dark opacity-70 hover:opacity-100 transition-opacity"
                    style={{ fontSize: '0.85rem' }}
                  >
                    {ref.phone}
                  </a>
                )}
                <a
                  href={`mailto:${ref.email}`}
                  className="font-sans hover:opacity-100 transition-opacity"
                  style={{ fontSize: '0.85rem', color: ref.color }}
                >
                  {ref.email}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}